module.exports = __webpack_public_path__ + "img/logo-kefuri-w.32842f13.png";